__turbopack_context__.v({
  "className": "manrope_b184ebb9-module__Fotz9G__className",
  "variable": "manrope_b184ebb9-module__Fotz9G__variable",
});
